<ngb-carousel [interval]="7000" class="embed-responsive-item">
  <ng-template ngbSlide *ngFor="let img of images; let index=index">
    <img [src]="img" class="carousel-image img-fluid" [alt]="alt+(index+1)" [width]="imageWidth" [height]="imageHeight">
  </ng-template>
</ngb-carousel>
